import CategoryGrid from './CategoryGrid';

export default CategoryGrid;
